import type { ParsedWorkbook } from './parseExcelWorkbook'

type WorkerResponse =
  | { ok: true; result: ParsedWorkbook }
  | { ok: false; error: string }

export function parseExcelWorkbookInWorker(
  arrayBuffer: ArrayBuffer
): Promise<ParsedWorkbook> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(
      new URL('./parseExcelWorkbook.worker.ts', import.meta.url),
      {
        type: 'module',
      }
    )

    worker.onmessage = (event: MessageEvent<WorkerResponse>) => {
      worker.terminate()
      if (event.data.ok) resolve(event.data.result)
      else reject(new Error(event.data.error))
    }

    worker.onerror = (event) => {
      worker.terminate()
      reject(new Error(event.message || 'Не удалось обработать файл'))
    }

    const arrayBufferKeptReusableOnMainThread = arrayBuffer
    worker.postMessage(arrayBufferKeptReusableOnMainThread)
  })
}
